export const CUSTOMER_ID = "customerId";
export const QUESTIONNAIRE_ID = "questionnaireId";
export const CASE_ID = "ohCaseId";
